import './channels';
import './web_components';
import './controllers';
import Primary from './primary';
import $ from 'jquery';

window.Primary = Primary;